export class BlogPosts {
	constructor() {
		document.querySelectorAll('.blog-posts[data-ajax="1"]').forEach((root) => {
			this.bind(root);
		});
	}

	bind(root) {
		const config = window.icarBlogPosts;

		if (!config?.ajaxUrl) {
			return;
		}

		const results = root.querySelector('.blog-posts__results');

		if (!results) {
			return;
		}

		let activeController = null;
		let requestSeq = 0;

		const getCurrentState = () => {
			const searchInput = root.querySelector('.blog-posts__search-input');
			const perPageSelect = root.querySelector('.blog-posts__per-page-select');
			const activeFilter = root.querySelector('.blog-posts__filter.is-active');

			return {
				blog_category: activeFilter?.dataset.blogCategory || 'all',
				s: searchInput?.value?.trim() || '',
				posts_per_page: perPageSelect?.value || '12',
				paged: '1',
			};
		};

		const fetchResults = async (params, { updateUrl = true, scroll = false, optimisticCategory } = {}) => {
			const seq = ++requestSeq;

			if (optimisticCategory !== undefined) {
				this.setActiveFilter(root, optimisticCategory);
			}

			if (activeController) {
				activeController.abort();
			}

			activeController = new AbortController();
			root.classList.add('is-loading');

			const body = new FormData();
			body.append('action', config.action);
			body.append('nonce', config.nonce);

			Object.entries(params).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					body.append(key, String(value));
				}
			});

			try {
				const response = await fetch(config.ajaxUrl, {
					method: 'POST',
					body,
					credentials: 'same-origin',
					signal: activeController.signal,
				});

				const payload = await response.json();

				if (seq !== requestSeq || !payload?.success) {
					return;
				}

				results.innerHTML = payload.data.html;

				if (payload.data.category !== undefined) {
					this.setActiveFilter(root, payload.data.category);
				}

				if (updateUrl) {
					this.updateUrl(params);
				}

				if (scroll) {
					root.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			} catch (error) {
				if (error?.name === 'AbortError') {
					return;
				}
			} finally {
				if (seq === requestSeq) {
					root.classList.remove('is-loading');
				}
			}
		};

		root.addEventListener('click', (event) => {
			const filter = event.target.closest('.blog-posts__filter');

			if (filter && root.contains(filter)) {
				event.preventDefault();

				const state = getCurrentState();
				state.blog_category = filter.dataset.blogCategory || 'all';
				state.paged = '1';

				fetchResults(state, {
					scroll: true,
					optimisticCategory: state.blog_category,
				});
				return;
			}

			const pageLink = event.target.closest('.blog-posts__pagination a');

			if (pageLink && root.contains(pageLink)) {
				event.preventDefault();

				const state = getCurrentState();
				state.paged = String(this.getPageFromLink(pageLink));

				fetchResults(state, { scroll: true });
			}
		});

		const searchForm = root.querySelector('.blog-posts__search');
		const searchInput = root.querySelector('.blog-posts__search-input');

		if (searchForm) {
			searchForm.addEventListener('submit', (event) => {
				event.preventDefault();

				const state = getCurrentState();
				state.paged = '1';

				fetchResults(state, { scroll: true });
			});
		}

		if (searchInput) {
			let lastSearch = searchInput.value.trim();

			searchInput.addEventListener('input', () => {
				const value = searchInput.value.trim();

				if (value === '' && lastSearch !== '') {
					const state = getCurrentState();
					state.s = '';
					state.paged = '1';

					fetchResults(state);
				}

				lastSearch = value;
			});
		}

		root.addEventListener('change', (event) => {
			const select = event.target.closest('.blog-posts__per-page-select');

			if (!select || !root.contains(select)) {
				return;
			}

			const state = getCurrentState();
			state.posts_per_page = select.value;
			state.paged = '1';

			fetchResults(state, { scroll: true });
		});
	}

	setActiveFilter(root, category) {
		root.querySelectorAll('.blog-posts__filter').forEach((link) => {
			link.classList.toggle('is-active', link.dataset.blogCategory === category);
		});
	}

	getPageFromLink(anchor) {
		const url = new URL(anchor.href, window.location.origin);
		const queryPage = url.searchParams.get('paged');

		if (queryPage) {
			return Math.max(1, parseInt(queryPage, 10));
		}

		const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);

		if (pathMatch) {
			return Math.max(1, parseInt(pathMatch[1], 10));
		}

		return 1;
	}

	updateUrl(params) {
		const url = new URL(window.location.href);

		url.searchParams.delete('blog_category');
		url.searchParams.delete('s');
		url.searchParams.delete('posts_per_page');
		url.searchParams.delete('paged');

		if (params.blog_category && params.blog_category !== 'all') {
			url.searchParams.set('blog_category', params.blog_category);
		}

		if (params.s) {
			url.searchParams.set('s', params.s);
		}

		if (params.posts_per_page && params.posts_per_page !== '12') {
			url.searchParams.set('posts_per_page', params.posts_per_page);
		}

		if (params.paged && params.paged !== '1') {
			url.searchParams.set('paged', params.paged);
		}

		window.history.pushState({}, '', url);
	}
}
